import script from "./MicrosoftLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MicrosoftLogo.vue?vue&type=script&setup=true&lang=ts"

import "./MicrosoftLogo.vue?vue&type=style&index=0&id=3731704a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3731704a"]])

export default __exports__